function updatePlanCardsForPicker(variantSelects) {
  const variants = JSON.parse(
    variantSelects.querySelector(
      'script[type="application/json"]'
    ).textContent
  );

  const baseVariant = variants.find(
    variant => variant.options.includes('No Plan')
  );

  if (!baseVariant) return;

  const productContainer =
    variantSelects.closest('.thb-product-detail');

  if (!productContainer) return;

  productContainer
    .querySelectorAll('.plan-card')
    .forEach(card => {
      const planValue = card.dataset.planValue;
      const priceElement =
        card.querySelector('.plan-card__price');

      if (!priceElement) return;

      const matchingVariant = variants.find(
        variant => variant.options.includes(planValue)
      );

      if (!matchingVariant) return;

      const difference =
        matchingVariant.price - baseVariant.price;

      if (difference <= 0) {
        priceElement.textContent = 'Included';
      } else {
        priceElement.textContent =
          `+$${(difference / 100).toFixed(2)}`;
      }
    });
}

function updatePlanCardNotesForPicker(variantSelects) {
  const productContainer =
    variantSelects.closest('.thb-product-detail');

  if (!productContainer) return;

  productContainer
    .querySelectorAll('.product-form__input--card')
    .forEach(fieldset => {
      const checkedInput = fieldset.querySelector(
        'input[type="radio"]:checked'
      );
      const selectedValue = checkedInput
        ? checkedInput.value
        : null;

      fieldset
        .querySelectorAll('.plan-card-note')
        .forEach(note => {
          note.hidden =
            note.dataset.planNoteValue !== selectedValue;

          if (document.getElementById('compare-plans')) {
            note
              .querySelectorAll('a')
              .forEach(link => {
                link.setAttribute('href', '#compare-plans');
              });
          }
        });
    });
}

function updateAllPlanCards() {
  document
    .querySelectorAll('variant-selects')
    .forEach(variantSelects => {
      updatePlanCardsForPicker(variantSelects);
      updatePlanCardNotesForPicker(variantSelects);
    });
}

document.addEventListener(
  'DOMContentLoaded',
  updateAllPlanCards
);

document.addEventListener(
  'product:variant-change',
  updateAllPlanCards
);